import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { setupScrollAnimations } from '../utils/scrollAnimations';
import SteelImage from './images/steel/Steel.jpg';
import SteelMaintenance from './images/steel/Steel Maintenance & Repair.jpg';
import SteelInstallation from './images/steel/Steel Installation.jpg';
import SteelFabrication from './images/steel/Structural Steel Fabrication.jpg';
import CustomSteelSolutions from './images/steel/Custom Steel Solutions.jpg';
import './style.css';

const Steel = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    setupScrollAnimations();
  }, []);
  
  return (
    <motion.main
      className="page-content"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
        <div className="service-content">
          {/* Hero Section with Image */}
          <div className="service-hero animate-on-scroll">
            <div className="service-hero-content">
              <h1>{t('services.steel.title')}</h1>
              <p className="service-hero-subtitle">
                {t('services.steel.subtitle')}
              </p>
            </div>
            <div className="service-hero-image">
              <img src={SteelImage} alt="Steel Services" className="hero-image" />
            </div>
          </div>
          
          {/* Services Grid with Images */}
          <div className="service-sections">
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🏗️</div>
                <h3>{t('services.steel.fabrication.title')}</h3>
                <p>
                  {t('services.steel.fabrication.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={SteelFabrication} alt="Structural Steel Fabrication" className="service-image" />
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🔧</div>
                <h3>{t('services.steel.installation.title')}</h3>
                <p>
                  {t('services.steel.installation.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={SteelInstallation} alt="Steel Installation" className="service-image" />
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🎨</div>
                <h3>{t('services.steel.custom.title')}</h3>
                <p>
                  {t('services.steel.custom.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={CustomSteelSolutions} alt="Custom Steel Solutions" className="service-image" />
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🛠️</div>
                <h3>{t('services.steel.maintenance.title')}</h3>
                <p>
                  {t('services.steel.maintenance.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={SteelMaintenance} alt="Steel Maintenance & Repair" className="service-image" />
              </div>
            </div>
          </div>
          
          {/* Features Section */}
          <div className="service-features">
            <h3>{t('services.steel.whyChoose.title')}</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">⭐</div>
                <div className="feature-text">{t('services.steel.whyChoose.item1')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⚙️</div>
                <div className="feature-text">{t('services.steel.whyChoose.item2')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">👷</div>
                <div className="feature-text">{t('services.steel.whyChoose.item3')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <div className="feature-text">{t('services.steel.whyChoose.item4')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⏰</div>
                <div className="feature-text">{t('services.steel.whyChoose.item5')}</div>
              </div>
            </div>
          </div>
          
          {/* Gallery Section */}
          <div className="service-gallery">
            <h3>{t('services.steel.gallery.title')}</h3>
            <div className="gallery-grid">
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 1</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 2</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 3</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 4</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Us Section */}
          <div className="service-contact-section">
            <div className="service-contact-content">
              <h3>{t('services.steel.contact.title')}</h3>
              <p>{t('services.steel.contact.description')}</p>
              <Link to="/contact?service=steel" className="service-contact-btn btn-animated hover-lift">
                {t('services.steel.contact.button')}
              </Link>
            </div>
          </div>
        </div>
    </motion.main>
  );
};

export default Steel;
